import { extractResourceStatePromise } from '@atlassian/jira-router-resources-assets-admin-settings/src/common/utils.tsx';
import { getResourceStore } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export type AssetsReportingConfig = {
	status: 'success' | 'error';
	data: AssetsReportingConfigResponse;
};

export type AssetsReportingConfigResponse = {
	isAssetsReportingEnabled: boolean;
};

export const getAssetsReportingConfig = async (): Promise<AssetsReportingConfig> => {
	try {
		const { storeState } = getResourceStore();
		const state = storeState.getState();
		const workspaceId = await extractResourceStatePromise(state.data);
		if (!workspaceId || typeof workspaceId !== 'string') {
			return { status: 'error', data: { isAssetsReportingEnabled: false } };
		}
		const url = `/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/config`;
		const response = await performGetRequest<AssetsReportingConfigResponse>(url);
		if (!response || typeof response.isAssetsReportingEnabled !== 'boolean') {
			return { status: 'error', data: { isAssetsReportingEnabled: false } };
		}
		return { status: 'success', data: response };
	} catch {
		return { status: 'error', data: { isAssetsReportingEnabled: false } };
	}
};
